import './Board.scss'
import { observer } from 'mobx-react';
import { betStore, gameStore, roundStore } from '../../platform/stores';
import removeIcon from '../../assets/icons/remove.svg'
import shuffleIcon from '../../assets/icons/shuffle.svg'
import { RoundStatus } from '../../platform/enums/round-status';
import { notificationService } from '../../platform/services';

export const Board = observer(() => {
  const { numbers, selectedNumbers } = betStore;
  const { openedNumbers, roundStatus } = roundStore;
  const { hotNumbers, coldNumbers, gameId } = gameStore;
  const numbersForShuffling = gameId === 8 ? [8, 7, 6, 5, 4, 3, 2, 1] : [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  const mobileNumbersForShuffling = [...numbersForShuffling].reverse();

  const selectNumber = (number: number) => {
    if (roundStatus === RoundStatus.Started) {
      const ok = betStore.selectNumber(number);
      if (!ok) {
        notificationService.show('NOTIFICATION_REACHED_MAX_SELECT_NUMBER', 'error');
      }
    }
  }

  const clearSelectedNumbers = () => {
    if (roundStatus === RoundStatus.Started) {
      betStore.clearSelectedNumbers();
    }
  }

  const selectRandomNumbers = () => {
    if (roundStatus === RoundStatus.Started) {
      betStore.selectRandomNumbers();
    }
  }

  const selectRandomNumbersByCount = (count: number) => {
    if (roundStatus === RoundStatus.Started) {
      betStore.selectRandomNumbersByCount(count);
    }
  }

  return (
    <div className="board-component">
      <div className="board-component-content flex-center">
        <div className="numbers">
          {
            numbers.map((number) =>
              <div
                className={`
                  number flex-center cursor-pointer
                  ${selectedNumbers.includes(number) ? 'selected' : ''}
                  ${openedNumbers.includes(number) ? 'winner' : ''}
                  ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}
                  ${roundStatus === RoundStatus.Started && hotNumbers.includes(number) ? 'hot' : ''}
                  ${roundStatus === RoundStatus.Started && coldNumbers.includes(number) ? 'cold' : ''}
                `}
                key={'board-' + number}
                onClick={() => selectNumber(number)}>
                {number}
              </div>
            )
          }
        </div>
        <div className="random-numbers-shuffle-container mobile-hidden">
          <div className="random-numbers-container">
            <div className="random-numbers">
              {
                numbersForShuffling.map((item) =>
                  <div key={item}
                       className={`
                        random-numbers-item flex-center cursor-pointer
                        ${gameId !== 8 ? 'ten' : ''}
                        ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}
                       `}
                       onClick={() => selectRandomNumbersByCount(item)}>
                    {item}
                  </div>
                )
              }
            </div>
            <div className={`button edit flex-center cursor-pointer ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}`}
                 onClick={() => selectRandomNumbers()}>
              <img src={shuffleIcon} alt="Shuffle icon"/>
            </div>
          </div>
          <div className={`button remove flex-center cursor-pointer ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}`}
               onClick={() => clearSelectedNumbers()}>
            <img src={removeIcon} alt="Remove icon"/>
          </div>
        </div>
      </div>
      <div className="mobile-random-shuffle-container">
        <div className="mobile-random-shuffle-container-content flex-between">
          <div className={`button remove flex-center cursor-pointer ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}`}
               onClick={() => clearSelectedNumbers()}>
            <img src={removeIcon} alt="Remove icon"/>
          </div>
          <div className="random-numbers">
            {
              mobileNumbersForShuffling.map((item) =>
                <div key={item}
                     className={`
                      random-numbers-item flex-center cursor-pointer
                      ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}
                     `}
                     onClick={() => selectRandomNumbersByCount(item)}>
                  {item}
                </div>
              )
            }
          </div>
          <div className={`button edit flex-center cursor-pointer ${roundStatus !== RoundStatus.Started ? 'disabled' : ''}`}
               onClick={() => selectRandomNumbers()}>
            <img src={shuffleIcon} alt="Shuffle icon"/>
          </div>
        </div>
      </div>
    </div>
  );
});
